import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { connect } from "react-redux";

import { selectIsGreaterThanSmall } from "~/store/ducks/application/browser";
import { selectTitle } from "~/store/ducks/domain/config";

import useTitle from "~/hooks/useTitle";

const Title = styled("span")`
  font-size: 14px;
  line-height: 48px;
`;

function BookTitle({ title, isGreaterThanSmall }) {
  useTitle(title);
  return isGreaterThanSmall && title.length > 0 && <Title>{title}</Title>;
}

BookTitle.propTypes = {
  title: PropTypes.string,
  isGreaterThanSmall: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    title: selectTitle(state),
    isGreaterThanSmall: selectIsGreaterThanSmall(state)
  };
}

export default connect(mapStateToProps)(BookTitle);
